import dayjs, { Dayjs } from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(timezone);

export const getDisabledDate = (date: Dayjs) => date.isAfter() && !date.isSame(dayjs(), 'day');
export const getAustraliaDisabledDate = (date: Dayjs) => {
  const selectedDateAustralia = dayjs.tz(date.format('YYYY-MM-DD'), 'Australia/Sydney');
  const nowAustralia = dayjs().tz('Australia/Sydney');
  return selectedDateAustralia.isAfter(nowAustralia, 'day');
};
export const getDisabledHours = () =>
  Array(24)
    .fill(null)
    .map((_, index) => index)
    .filter(h => h >= new Date().getHours() + 1);
